import axios from 'axios';
import endPoints from '../const/endPoints';
import convertPayloadToQueryParams from './convertPayloadToQueryParams';
export const revokeAccessToken = async (baseURL, clientId, accessToken) => {
    const requestBody = {
        token_type_hint: 'access_token',
        token: accessToken
    };
    const encodedClientId = btoa(`${clientId}:`);
    try {
        await axios.post(`${baseURL}${endPoints.REVOKE}`, convertPayloadToQueryParams(requestBody), {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                Authorization: `Basic ${encodedClientId}`
            }
        });
    }
    catch (error) {
        window.console.log(error);
    }
};
export default revokeAccessToken;
